import type { MarqueeState } from "../../hooks/useSelectionMarquee";

/**
 * The drag surface and the marquee itself. Must exactly cover the stage frame,
 * since the marquee hook measures pointer positions against this element's
 * bounding rect.
 */
export function SelectionOverlay({ marquee }: { marquee: MarqueeState }) {
  const { rectPx, handlers } = marquee;
  const hasRect = rectPx && rectPx.width > 0 && rectPx.height > 0;

  return (
    <div
      className="absolute inset-0 cursor-crosshair touch-none select-none"
      {...handlers}
    >
      {hasRect && (
        <div
          className="pointer-events-none absolute border border-dashed border-white bg-white/20"
          style={{
            left: rectPx.x,
            top: rectPx.y,
            width: rectPx.width,
            height: rectPx.height,
          }}
        />
      )}
    </div>
  );
}
